import React from 'react'
import { TEXT_SHORT_KEY } from '@mc/feature-variables'
import { UrgencyCopy, UrgencyCopyProps } from './UrgencyCopy'

export const UrgencyTextShort = (props: Omit<UrgencyCopyProps, 'textKey'>) => (
  <UrgencyCopy {...props} textKey={TEXT_SHORT_KEY} />
)
